import { axiosInstance } from './auth';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchClients = async (token, params) => {
  const response = await axiosInstance.get(
    `${API_URL}/admin/fetchClients?${params}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const toggleApiKeyStatus = async (token, apiKeyId, shouldEnable) => {
  const response = await axiosInstance.post(
    `${API_URL}/admin/toggleApiKeyStatus`,
    { api_key_id: apiKeyId, should_enable: shouldEnable },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateAdminProfile = async (token, firstName, lastName) => {
  const body = {};
  if (firstName !== undefined) body.first_name = firstName;
  if (lastName !== undefined) body.last_name = lastName;
  const response = await axiosInstance.post(
    `${API_URL}/admin/updateProfile`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const createAdminApiKey = async (token) => {
  const response = await axiosInstance.get(
    `${API_URL}/admin/getApiKey`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}; 

export const createCustomUser = async (userData, token) => {
    const response = await axiosInstance.post(
      `${API_URL}/admin/users/custom`,
      userData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
  return response.data;
}